/* eslint-disable no-empty-pattern */

/**
 * Actions.
 *
 * @param {Function} fetch
 * @param {String} apiUrl
 * @param {FetchPath} fetchPath
 * @param {Function} yodaFormatter
 * @return {Object}
 */
export default ({ fetch, apiUrl, fetchPath, yodaFormatter }) => ({
  /**
   * Writes an upload file to the server.
   *
   * @param {File} file
   * @returns {Promise<void>}
   */
  async xhrSaveFile({}, file) {
    const response = await fetch(`${apiUrl}/basket/upload-import-file`, { method: 'POST', body: file })
    return response.json()
  },

  /**
   * Submits a request to create a new basket file import entity.
   *
   * @param {Function} commit
   * @param {Object} payload
   * @return {Promise}
   */
  async xhrCreateBasketFileImport({ commit }, payload) {
    const result = await fetchPath.run(
      {
        method: 'POST',
        path: '/yoda/api/basket-file-imports',
        data: payload,
        jsonPath: ['content', 'data'],
      },
    )
    const entity = yodaFormatter(result)

    await commit('SET_BASKET_FILE_IMPORT', { entity })

    return entity
  },

  /**
   * Run the import.
   *
   * @param {Function} commit
   * @param {Object} basketFileImport
   * @returns {Promise}
   */
  async xhrRunImport({ commit }, { basketFileImport }) {
    const result = await fetchPath.run(
      {
        method: 'PUT',
        path: `/yoda/api/basket-file-imports/${basketFileImport.id}/import`,
        data: {},
        jsonPath: ['content', 'data'],
      },
    )
    const entity = yodaFormatter(result)

    await commit('SET_BASKET_FILE_IMPORT', { entity })

    return entity
  },
})
